import React from 'react';
import {HashLink as Link} from 'react-router-hash-link';
import {Helmet} from 'react-helmet';
import {MailIcon,SupportIcon,InformationCircleIcon,ChatAlt2Icon,ScaleIcon,CreditCardIcon,OfficeBuildingIcon} from '@heroicons/react/outline';
import {sprintf} from 'sprintf-js';
import locales from '../../locales/locales';
import Navbar from '../navbar/navbar';
import Footer from '../footer/footer';
const Contact=({globalSettings})=>{
  return (
    <div className='min-h-screen flex flex-col bg-white'>
      <Helmet>
        <title>NekoTranslate - {locales.contactPageTitle[globalSettings.lang]}</title>
      </Helmet>
      <Navbar 
        globalSettings={globalSettings}
      />
      <div className='flex-1 bg-purple-50 pt-16'>
        <div className='max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24'>
          <div className='text-center mb-10'>
            <h1 className='text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight'>
              {locales.contactHeadingPrefix[globalSettings.lang]}
              <span className='text-purple-800'>
                {locales.contactHeadingHighlight[globalSettings.lang]}
              </span>
              {locales.contactHeadingSuffix[globalSettings.lang]}
            </h1>
            <p className='mt-4 text-xl text-gray-600'>
              {locales.contactSubtext[globalSettings.lang]}
            </p>
          </div>
          <div className='bg-white p-8 rounded-xl shadow-lg border border-gray-200'>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-10'>
              <div className='flex flex-col items-center text-center'>
                <div className='h-14 w-14 bg-purple-100 rounded-full flex items-center justify-center mb-4'>
                  <MailIcon className='h-7 w-7 text-purple-800' />
                </div>
                <h3 className='text-lg font-bold text-gray-900 mb-2'>
                  {locales.contactGeneral[globalSettings.lang]}
                </h3>
                <p className='text-gray-600 text-sm'>
                  <Link to="mailto:contact@nekotranslate.ai" className='text-purple-800 hover:text-purple-600 break-all'>contact@nekotranslate.ai</Link>
                </p>
              </div>
              <div className='flex flex-col items-center text-center'>
                <div className='h-14 w-14 bg-purple-100 rounded-full flex items-center justify-center mb-4'>
                  <SupportIcon className='h-7 w-7 text-purple-800' />
                </div>
                <h3 className='text-lg font-bold text-gray-900 mb-2'>
                  {locales.contactSupport[globalSettings.lang]}
                </h3>
                <p className='text-gray-600 text-sm'>
                  <Link to="mailto:support@nekotranslate.ai" className='text-purple-800 hover:text-purple-600 break-all'>support@nekotranslate.ai</Link>
                </p>
              </div>
              <div className='flex flex-col items-center text-center'>
                <div className='h-14 w-14 bg-purple-100 rounded-full flex items-center justify-center mb-4'>
                  <InformationCircleIcon className='h-7 w-7 text-purple-800' />
                </div>
                <h3 className='text-lg font-bold text-gray-900 mb-2'>
                  {locales.contactInquiries[globalSettings.lang]}
                </h3>
                <p className='text-gray-600 text-sm'>
                  <Link to="mailto:info@nekotranslate.ai" className='text-purple-800 hover:text-purple-600 break-all'>info@nekotranslate.ai</Link>
                </p>
              </div>
              <div className='flex flex-col items-center text-center'>
                <div className='h-14 w-14 bg-purple-100 rounded-full flex items-center justify-center mb-4'>
                  <CreditCardIcon className='h-7 w-7 text-purple-800' />
                </div>
                <h3 className='text-lg font-bold text-gray-900 mb-2'>
                  {locales.contactBillingSubscriptions[globalSettings.lang]}
                </h3>
                <p className='text-gray-600 text-sm'>
                  <Link to="mailto:billing@nekotranslate.ai" className='text-purple-800 hover:text-purple-600 break-all'>billing@nekotranslate.ai</Link>
                </p>
              </div>
              <div className='flex flex-col items-center text-center'>
                <div className='h-14 w-14 bg-purple-100 rounded-full flex items-center justify-center mb-4'>
                  <ChatAlt2Icon className='h-7 w-7 text-purple-800' />
                </div>
                <h3 className='text-lg font-bold text-gray-900 mb-2'>
                  {locales.contactFeedbackBugs[globalSettings.lang]}
                </h3>
                <p className='text-gray-600 text-sm'>
                  <Link to="mailto:feedback@nekotranslate.ai" className='text-purple-800 hover:text-purple-600 break-all'>feedback@nekotranslate.ai</Link>
                </p>
              </div>
              <div className='flex flex-col items-center text-center'>
                <div className='h-14 w-14 bg-purple-100 rounded-full flex items-center justify-center mb-4'>
                  <ScaleIcon className='h-7 w-7 text-purple-800' />
                </div>
                <h3 className='text-lg font-bold text-gray-900 mb-2'>
                  {locales.contactLegalMatters[globalSettings.lang]}
                </h3>
                <p className='text-gray-600 text-sm'>
                  <Link to="mailto:legal@nekotranslate.ai" className='text-purple-800 hover:text-purple-600 break-all'>legal@nekotranslate.ai</Link>
                </p>
              </div>
              <div className='flex flex-col items-center text-center'>
                <div className='h-14 w-14 bg-purple-100 rounded-full flex items-center justify-center mb-4'>
                  <OfficeBuildingIcon className='h-7 w-7 text-purple-800' />
                </div>
                <h3 className='text-lg font-bold text-gray-900 mb-2'>
                  {locales.contactBusinessInquiries[globalSettings.lang]}
                </h3>
                <p className='text-gray-600 text-sm'>
                  <Link to="mailto:office@nekotranslate.ai" className='text-purple-800 hover:text-purple-600 break-all'>office@nekotranslate.ai</Link>
                </p>
              </div>
            </div>
            <div className='border-t border-gray-200 pt-8 mt-4'>
              <h2 className='text-2xl font-bold text-gray-900 mb-4 text-center'>
                {locales.contactFaqHeading[globalSettings.lang]}
              </h2>
              <div className='space-y-6 mt-6'>
                <div className='bg-purple-50 p-6 rounded-lg'>
                  <h3 className='text-lg font-medium text-gray-900'>
                    {locales.contactFaqResponseTimeQuestion[globalSettings.lang]}
                  </h3>
                  <p className='mt-2 text-gray-600'>
                    {locales.contactFaqResponseTimeAnswer[globalSettings.lang]}
                  </p>
                </div>
                <div className='bg-purple-50 p-6 rounded-lg'>
                  <h3 className='text-lg font-medium text-gray-900'>
                    {locales.contactFaqFeedbackQuestion[globalSettings.lang]}
                  </h3>
                  <p className='mt-2 text-gray-600'>
                    {locales.contactFaqFeedbackAnswer[globalSettings.lang]}
                  </p>
                </div>
                <div className='bg-purple-50 p-6 rounded-lg'>
                  <h3 className='text-lg font-medium text-gray-900'>
                    {locales.contactFaqTranslationIssueQuestion[globalSettings.lang]}
                  </h3>
                  <p className='mt-2 text-gray-600'>
                    {sprintf(
                      locales.contactFaqTranslationIssueAnswer[globalSettings.lang],
                      'support@nekotranslate.ai',
                      'feedback@nekotranslate.ai',
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer 
        globalSettings={globalSettings}
      />
    </div>
  );
};
export default Contact;

